<%= turbo_stream.prepend "photos", @photo %>
